"use client"

import type { ButtonHTMLAttributes, ReactNode } from "react"

interface NineSliceButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode
  className?: string
}

export const NineSliceButton = ({ children, className = "", ...props }: NineSliceButtonProps) => {
  return (
    <button
      className={`nine-slice-btn text-white font-bold text-xl px-8 py-4 transition-all transform hover:scale-105 hover:brightness-110 active:scale-95 disabled:opacity-50 disabled:hover:scale-100 flex items-center justify-center gap-1 ${className}`}
      style={{ touchAction: 'manipulation', ...props.style }}
      {...props}
    >
      {children}
    </button>
  )
}
